let screenW = $(window).width()
let screenH = $(window).height()

function breakpoint(breakpoint)
{
  let breakpoints = {
    'xs': 0,
    'sm': 576,
    'md': 767,
    'lg': 992,
    'xl': 1280,
    'xxl': 1920,
    'fhd': 2000,
    'screenW': screenW,
    'screenH': screenH,
  }
  return breakpoints[breakpoint]
}

function breakpointUp(value)
{
  return breakpoint('screenW') >= breakpoint(value)
}

function breakpointDown(value)
{
  return breakpoint('screenW') < breakpoint(value)
}

function screenSizeCoefficient()
{
  let coefficient = 1
  let screenBreakpoint = 1440
  if (breakpoint('screenW') > screenBreakpoint) {
    coefficient = breakpoint('screenW') /  screenBreakpoint
  }

  coefficient = coefficient < 0.7 ? 0.7 : coefficient

  return coefficient
}

export { breakpoint, screenSizeCoefficient, breakpointUp, breakpointDown }
